var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"buttons-group\">\n  <button class=\"wrap-nodes\">Group nodes</button>\n  <button class=\"remove-nodes btn-danger\">Remove nodes</button>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_mode/multiple_selection.hbs
// module id = 139
// module chunks = 0